const data_criticity = {
  1: {
    value: 1,
    en: 'Very Low',
    fr: 'Très Faible',
  },
  2: {
    value: 2,
    en: 'Low',
    fr: 'Faible',
  },
  3: {
    value: 3,
    en: 'Medium',
    fr: 'Moyenne',
  },
  4: {
    value: 4,
    en: 'High',
    fr: 'Élevée',
  },
  5: {
    value: 5,
    en: 'Very High',
    fr: 'Très Élevée',
  },
};

export default data_criticity;
